import React from 'react';

import SharedResourceLayout, {
  SharedResourceStep,
} from '@layouts/AppLayout/SharedResourceLayout';

import AccessResource from '@views/SharedResource/Access';
import VerifyEmail from '@views/SharedResource/Verify';

/**
 * Page that handles shared resource access
 */
export default function SharedResourcePage() {
  return (
    <SharedResourceLayout>
      {({ share_id, handleVerified, step, setUserName, reset }) => {
        const handleSetUserName = (name: string) => {
          setUserName(name);
        };

        switch (step) {
          case SharedResourceStep.VerifyEmail:
            return (
              <VerifyEmail onVerified={handleVerified} share_id={share_id} />
            );
          case SharedResourceStep.Access:
            return (
              <AccessResource
                share_id={share_id}
                onSetUserName={handleSetUserName}
                onError={reset}
              />
            );
          default:
            return null;
        }
      }}
    </SharedResourceLayout>
  );
}
